<template>
  <base-content :data="data"
    :index="index">
      <template #card-header>
        <partial-title
          :title="title"
          :link="link"
          :lineClamp="3"
        />
      </template>

      <template #card-body>
        <ul>
          <li v-if="studyType || status" class="row-content t-sm t-overflow">
            <span v-if="studyType" class="t-600">{{studyType}}</span>
            <span v-if="studyType && status">, </span>
            <span v-if="status">{{status}}</span>
          </li>
          <partial-sponsors v-if="!isEmpty(sponsors)" :sponsors="sponsors" />
          <partial-locations v-if="!isEmpty(locations)" :locations="locations" />
          <matches class="mt-2" v-if="!isEmpty(matches)" :matches="matches" />
        </ul>
      </template>
      <template #card-footer>
        <li v-if="data.start_date" class="row-content">
          <i class="fa fa-hourglass-start row-content--side"></i>
          <span v-line-clamp="1" class="row-content--main">{{ data.start_date | formatDate('YYYY-MM-DD') }}
            <span v-if="latestCompletionDate"> &#8594; {{ latestCompletionDate | formatDate('YYYY-MM-DD') }}</span>
          </span>
        </li>

        <li v-if="!isEmpty(phases)" class="row-content">
          <i class="fa row-content--side fa-flag t-grey"></i>
          <span class="row-content--main">
            {{ phases | separateByComma('phase')}}
          </span>
        </li>
      </template>
      <template #card-actions>
        <slot name="actions"></slot>
      </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/clinicalTrial'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialLocations from '@/components/search/results/partials/Locations.vue'
import PartialSponsors from '@/components/search/results/partials/Sponsors.vue'

export default {
  name: 'clinicalTrialResultBlock',
  mixins: [processing],
  components: {
    Matches,
    PartialTitle,
    BaseContent,
    PartialLocations,
    PartialSponsors
  },
  computed: {
    latestCompletionDate () {
      return this.data.completion_date || this.data.primary_completion_date || null
    }
  }
}
</script>
